/* 🤖 this file was generated by svg-to-ts */
export const mgcIconFlag3Filled: {
  name: 'flag-3-filled';
  data: string;
} = {
  name: 'flag-3-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.035 2.343c-.392.12-.788.496-.945.897-.066.17-.071.691-.08 9.038-.012 9.948-.038 9.096.288 9.422a.984.984 0 0 0 1.403.001c.303-.303.299-.262.299-2.801v-2.245l6.59-2.854c3.625-1.57 6.694-2.906 6.821-2.969.307-.152.529-.382.683-.706.112-.237.126-.305.126-.626s-.014-.389-.126-.626a1.454 1.454 0 0 0-.643-.688c-.239-.121-13.287-5.774-13.503-5.85-.201-.071-.673-.067-.913.007"/></svg>`
};
